"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Titulo = void 0;
var react_1 = __importDefault(require("react"));
var Tipografia_1 = require("../Tipografia");
var GradacaoNeutros_1 = __importDefault(require("../../Cores/GradacaoNeutros "));
var Titulo = function (_a) {
    var _b = _a.tag, tag = _b === void 0 ? "div" : _b, _c = _a.negrito, negrito = _c === void 0 ? false : _c, _d = _a.cor, cor = _d === void 0 ? GradacaoNeutros_1.default.PretoMU900 : _d, conteudo = _a.conteudo, _e = _a.overline, overline = _e === void 0 ? false : _e, _f = _a.tipo, tipo = _f === void 0 ? "cabecalho3" : _f, _g = _a.children, children = _g === void 0 ? null : _g, title = _a.title, corOnHover = _a.corOnHover, style = _a.style, onClick = _a.onClick;
    var tamanhoPadrao = {
        "display1": 80,
        "display2": 48,
        "cabecalho1": 32,
        "cabecalho2": 24,
        "cabecalho3": 18,
    };
    var lineHeightPadrao = {
        "display1": 88,
        "display2": 56,
        "cabecalho1": 40,
        "cabecalho2": 32,
        "cabecalho3": 26,
    };
    var letterSpacingPadrao = {
        "display1": -2,
        "display2": -1,
        "cabecalho1": -0.5,
        "cabecalho2": -0.25,
        "cabecalho3": -0.25,
    };
    var tamanhoFonte = tamanhoPadrao[tipo.toLowerCase()];
    var lineHeight = (tipo) ? "".concat(lineHeightPadrao[tipo.toLowerCase()], "px") : "20px";
    var letterSpacing = (tipo) ? "".concat(letterSpacingPadrao[tipo.toLowerCase()], "px") : "0px";
    var fontWeight = (negrito) ? 700 : 400;
    return (react_1.default.createElement(Tipografia_1.Tipografia, { tag: tag, label: children !== null && children !== void 0 ? children : conteudo, size: tamanhoFonte, overline: overline, cor: cor, espacamentoLinha: lineHeight, espacamentoCaractere: letterSpacing, negrito: fontWeight, corOnHover: corOnHover, style: __assign({ cursor: onClick ? 'pointer' : 'default' }, style), title: title, onClick: onClick }));
};
exports.Titulo = Titulo;
